module.exports = "https://static.wmbcdn.com/uniweb/images/3bf6dcff3fff96fb98e0cbf41dfb4829.svg";